export const TEXT_INPUT_DEFAULT_MIN_LENGTH = 5;
export const TEXT_INPUT_DEFAULT_MAX_LENGTH = 50;

export const TEXT_INPUT_DEFAULT_ALERT_MESSAGE = `(${TEXT_INPUT_DEFAULT_MIN_LENGTH}-${TEXT_INPUT_DEFAULT_MAX_LENGTH} characters)`;
